import { useSnapshot } from "valtio";
import { z } from "zod";

import { persistedProxy } from "@/utils/persistedState";

export const profileState = persistedProxy(
  { defaultClient: null as number | null },
  "blis.user.profile",
  z.object({
    defaultClient: z.coerce.number<number>().nullable(),
  }),
);

export function useProfileSettings() {
  const state = useSnapshot(profileState);
  return {
    state,
    setDefaultClient: (clientId: number | null | undefined) => {
      profileState.defaultClient = clientId ?? null;
    },
  };
}
